import React, { useState } from 'react';
import { FiShoppingCart, FiCheck } from 'react-icons/fi';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

const PICKLE_EMOJIS = ['🥒', '🫙', '🌶️', '🥭', '🧄', '🫚'];

const ProductCard = ({ product, orderWindowOpen }) => {
  const { addToCart, cartItems } = useCart();
  const { isAuthenticated, login } = useAuth();
  const [quantity, setQuantity] = useState(product.minOrderKg || 0.5);
  const [added, setAdded] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);

  const inCart = cartItems.find((item) => item.productId === product._id);
  const emoji = PICKLE_EMOJIS[Math.floor(Math.random() * PICKLE_EMOJIS.length)];
  const imageSrc = product.imageUrl || product.image || '';

  const handleDecrease = () => {
    const step = 0.5;
    const min = product.minOrderKg || 0.5;
    setQuantity((prev) => Math.max(min, prev - step));
  };

  const handleIncrease = () => {
    const step = 0.5;
    const max = product.maxOrderKg || 10;
    setQuantity((prev) => Math.min(max, prev + step));
  };

  const handleAddToCart = () => {
    if (!isAuthenticated) {
      login();
      return;
    }
    if (!orderWindowOpen) {
      toast.warning('Order window is currently closed.');
      return;
    }

    addToCart(product, quantity);
    setAdded(true);
    toast.success(`${product.name} added to cart!`);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <div className="product-card">
      <div className="product-card-image">
        {imageSrc && !imageFailed ? (
          <img
            src={imageSrc}
            alt={product.name}
            onError={() => setImageFailed(true)}
          />
        ) : (
          <span style={{ fontSize: '5rem', lineHeight: 1 }}>{emoji}</span>
        )}
      </div>
      <div className="product-card-body">
        <h3 className="product-card-name">{product.name}</h3>
        {product.nameGujarati && (
          <p className="product-card-name-guj">{product.nameGujarati}</p>
        )}
        <p className="product-card-desc">{product.description}</p>
        <div className="product-card-price">
          ₹{product.pricePerKg} <span>per kg</span>
        </div>

        <div className="quantity-selector">
          <label>Qty (kg):</label>
          <div className="qty-controls">
            <button className="qty-btn" onClick={handleDecrease}>−</button>
            <input
              className="qty-value"
              value={quantity}
              readOnly
            />
            <button className="qty-btn" onClick={handleIncrease}>+</button>
          </div>
        </div>

        <div className="product-subtotal">
          Subtotal: <strong>₹{(quantity * product.pricePerKg).toFixed(0)}</strong>
        </div>

        <button
          className={`btn btn-primary ${!orderWindowOpen ? 'btn-disabled' : ''}`}
          onClick={handleAddToCart}
          disabled={!orderWindowOpen}
        >
          {added ? (
            <><FiCheck /> Added!</>
          ) : inCart ? (
            <><FiShoppingCart /> Update Cart</>
          ) : (
            <><FiShoppingCart /> Add to Cart</>
          )}
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
